import React, { useState } from "react";
import { OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import { IoReload } from "react-icons/io5";
import queryClient from "../../../config/queryClient";

const ReloadButton = ({ moduleName }) => {
  const [loading, setLoading] = useState(false);

  const handleRefresh = async () => {
    if (!moduleName) return;

    setLoading(true);
    try {
      if (Array.isArray(moduleName)) {
        await Promise.all(
          moduleName.map((module) => queryClient.invalidateQueries(module))
        );
      } else {
        await queryClient.invalidateQueries(moduleName);
      }
    } finally {
      setTimeout(() => setLoading(false), 500); // optional delay for smoother UX
    }
  };

  return (
    <>
      {moduleName && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
        >
          <div role="button" id="collapse-header" onClick={handleRefresh}>
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <IoReload size={20} />
            )}
          </div>
        </OverlayTrigger>
      )}
    </>
  );
};

export default ReloadButton;
